module.exports = __webpack_public_path__ + "static/2-ea29128e86c7c3f736207bf2a1781b59.png";